import { Form, Input } from "antd";
import React, { ChangeEvent, CSSProperties } from "react";
import "./FormItemInput.scss";
import { useTranslation } from "react-i18next";

interface FormItemInputProps {
  name: string;
  placeholder?: string;
  label: string;
  rules: { required: boolean; message?: string };
  defaultValue?: string;
  disabled?: boolean;
  prefix?: string;
  onChangeFunction?: (e: ChangeEvent<HTMLInputElement>) => void;
  maxLength?: number;
  onlyNumber?: boolean;
  style?: CSSProperties;
  unlimitedBtnVisible?: boolean;
  setUnlimitedFn?: () => void;
}

const FormItemInput: React.FC<FormItemInputProps> = ({
  name,
  placeholder,
  rules,
  label,
  defaultValue,
  disabled,
  prefix,
  onChangeFunction,
  maxLength,
  onlyNumber,
  style,
  unlimitedBtnVisible,
  setUnlimitedFn,
}) => {
  const { t } = useTranslation();
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const keyCode = event.keyCode || event.which;

    if ((keyCode < 48 || keyCode > 57) && [8, 46, 37, 39].indexOf(keyCode) === -1) {
      event.preventDefault();
    }
  };

  return (
    <Form.Item
      className={`form-item__input`}
      name={name}
      label={label}
      style={style}
      rules={[{ required: rules.required, message: rules.message }]}
    >
      <Input
        className={`input ${unlimitedBtnVisible && "with-unlimited-btn"}`}
        prefix={prefix ? <img src={prefix} alt={"prefix"} /> : null}
        onChange={onChangeFunction}
        placeholder={placeholder}
        defaultValue={defaultValue}
        disabled={disabled}
        maxLength={maxLength}
        onKeyPress={onlyNumber ? handleKeyPress : undefined}
        addonAfter={
          unlimitedBtnVisible ? (
            <button className={"unlim-btn"} onClick={setUnlimitedFn} type="button">
              {t("Unlimited")}
            </button>
          ) : null
        }
      />
    </Form.Item>
  );
};

export default FormItemInput;
